import { useState } from 'react';
import getApiError from 'services/getApiError';
import { registerUserForFreeShopProduct } from './workshopApi';

export interface RegisterUserForFreeWorkshopOptions {
  action: 'COMPLETE';
  owner_id: string;
  shop_product_id: string;
}

const useUserFreeWorkshopRegistration = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const registerUserForFreeWorkshop = (
    data: RegisterUserForFreeWorkshopOptions
  ) => {
    setLoading(true);
    return registerUserForFreeShopProduct(data)
      .catch(e => {
        const err = getApiError(e);

        setError(err);
        return Promise.reject(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    registerUserForFreeWorkshop,
    freeWorkshopRegistrationInProgress: loading,
    error
  };
};

export default useUserFreeWorkshopRegistration;
